import { rando } from '../../../lib/rando-sidecar'
import { createId } from '../../../main/common'
import { EVoyageCrewCreateMethod } from '../multi/voyageMessageCrewCreate'
import { voyageMessageCrewCreate } from '../multi/voyageMessageCrewCreate-sidecar'
import { EVoyageCrewType } from '../voyageCrew'
import { voyageTilemap } from '../voyageTilemap-sidecar'

export function run_boarded(min: number, max: number) {
  let num = rando.i(min, max)
  for (let i = 0; i < num; i++) {
    setTimeout(() => {
      let fl = voyageTilemap.getRandomFloor()
      voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
        crewId: createId(),
        i: fl.i,
        j: fl.j,
        team: 1,
        type: EVoyageCrewType.Alien,
        method: EVoyageCrewCreateMethod.Teleport,
        energy: 0,
      })
    }, 1000 * i)
  }
}
